import modeType from './modeType'

const state = {
  syncscroll: true,
  // Split view by default on desktop; checkResponsive downgrades to a single
  // pane on mobile, and a ?view/?edit URL still overrides.
  currentMode: modeType.both
}

export default state
